module.exports = __webpack_public_path__ + "static/media/cash.deebd4b7.svg";